import { useState, useEffect } from 'react'
import {
  BusinessSetting,
  isSettingFieldEditable,
} from 'modules/business/types/business'
import { TIME_DATA } from 'modules/report/components/SettingsOption/data'
import { NotificationType } from 'modules/report/constants'

export type SettingsType = 'notificationSetting' | 'dailyReportSendingTime'

interface Props {
  type: SettingsType
  setting: BusinessSetting
}

function useDescriptionFromType({ type, setting }: Props): string {
  const [description, setDescription] = useState('')

  const {
    enableReceivingDailyReport,
    monthlyReportEnabled,
    dailyReviewEnabled,
    dailyReportSendingTime,
    subscribePayoutLineNotifyEnabled,
    weeklyOutOfStockReportEnabled,
  } = setting

  useEffect(() => {
    if (type === 'notificationSetting') {
      const enabled = []
      if (
        enableReceivingDailyReport &&
        isSettingFieldEditable(setting, 'enableReceivingDailyReport')
      ) {
        enabled.push(NotificationType.DailySales)
      }
      if (
        monthlyReportEnabled &&
        isSettingFieldEditable(setting, 'monthlyReportEnabled')
      ) {
        enabled.push(NotificationType.MonthlySales)
      }
      if (
        dailyReviewEnabled &&
        isSettingFieldEditable(setting, 'dailyReviewEnabled')
      ) {
        enabled.push(NotificationType.Reviews)
      }
      if (
        subscribePayoutLineNotifyEnabled &&
        isSettingFieldEditable(setting, 'subscribePayoutLineNotifyEnabled')
      ) {
        enabled.push(NotificationType.Payout)
      }
      if (
        weeklyOutOfStockReportEnabled &&
        isSettingFieldEditable(setting, 'weeklyOutOfStockReportEnabled')
      ) {
        enabled.push(NotificationType.OutOfStockMenus)
      }

      if (enabled.length === 0) {
        setDescription('(ไม่มีการตั้งค่าการแจ้งเตือน)')
      } else {
        setDescription(enabled.join(', '))
      }
    } else if (type === 'dailyReportSendingTime') {
      const initialTime = TIME_DATA.find(
        time => dailyReportSendingTime === time.value,
      )
      if (initialTime) {
        setDescription(initialTime.title)
      }
    }
  }, [
    enableReceivingDailyReport,
    monthlyReportEnabled,
    dailyReviewEnabled,
    dailyReportSendingTime,
    subscribePayoutLineNotifyEnabled,
    weeklyOutOfStockReportEnabled,
    setting,
    type,
  ])

  return description
}

export default useDescriptionFromType
